import ReactTable from 'react-table';
import React from 'react';
import PropTypes from 'prop-types';

// Local Deps
import './PackagingInfo.scss';
import { columns } from './gridConfig';
import makePackagingInfoObj from './makePackagingInfoObj';

export default class PackagingInfoGrid extends React.PureComponent {
  static propTypes = {
    packagingInfoText: PropTypes.string.isRequired,
  };

  render() {
    const { packagingInfoText } = this.props;
    const packagingInfo = makePackagingInfoObj(packagingInfoText)

    return (
      <div className="nf-packaging-info__grid">
        <ReactTable
          data={packagingInfo}
          columns={columns}
          defaultPageSize={packagingInfo.length < 5 ? packagingInfo.length : 5}
          showPagination={packagingInfo.length > 5}
          noDataText={packagingInfo.length ? 'No Data Found' : null}
          style={{ textAlign: 'center' }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/PackagingInfoGrid/PackagingInfoGrid.jsx